import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { Service } from '../services';
import { AngularFireAnalytics } from '@angular/fire/analytics';

@Component({
  selector: 'app-loginupdate',
  templateUrl: './loginupdate.component.html',
  styleUrls: ['./loginupdate.component.sass']
})
export class LoginupdateComponent implements OnInit {
  public typeAccount;
  public subscriber = '';
  public ssn = '';
  public securityCode = '';
  public email = '';
  public acceptedTerms = false;
  public passwd = '';
  public pswdOk = '';
  public alphanumber = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  public errorListPass = [];
  public errorP = false;
  public sideNavDisplayFlag = false;
  public accountType = '';
  public accountSubType = '';
  public timeoutResendCodeFlag = false;
  public txtType = '';
  public msj = '';
  public scremView=1;
  public token: string = sessionStorage.getItem("token");
  constructor(public AngularFireAnalytics:AngularFireAnalytics,private services: Service, private router: Router, private loadingScreenService: LoadingScreenService, private global: GlobalService) {
    this.AngularFireAnalytics.setCurrentScreen("Actualización de Registro");
    this.AngularFireAnalytics.logEvent("Actualización de Registro-Screenview");
   }

  ngOnInit() {
  }
  validateInputs() {
    var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if ((this.accountType === 'I' && this.accountSubType === 'P') || (this.accountType === 'I3' && this.accountSubType === 'P')) {
      return emailRegex.test(this.email) && this.securityCode.length > 0;
    }
    else {
      if (this.typeAccount != 'G') {
        return (
          this.ssn.length > 0 &&
          this.ssn.length === 4
        );
      }
      else {
        return (this.securityCode.length > 0);
      }
    }
  }
  validateInputSecurityCode() {
    if (this.securityCode !== undefined && this.securityCode !== undefined) {
      return (this.securityCode.length > 0 && (this.securityCode.length === 4 || this.securityCode.length === 6));
    }
    else {
      return false;
    }
  }
  changeSideNavDisplay() {
    this.sideNavDisplayFlag = !this.sideNavDisplayFlag;
  }
  updateRegister() {
    let idUser: number;
    let objAccounts;
    let userName2: string;
    if (this.typeAccount != 'G' && this.ssn.length < 4) {
      this.global.notif('Debe ingresar los datos solicitados.');
      this.loadingScreenService.stopLoading();
    }
    else if (this.typeAccount == 'G' && this.securityCode.length == 0) {
      this.global.notif('Debe ingresar los datos solicitados.');
      this.loadingScreenService.stopLoading();
    }
    else {
      this.loadingScreenService.startLoading();
      this.services.updateRegister(this.subscriber, this.securityCode, this.ssn, this.token).subscribe(data => {
        this.loadingScreenService.stopLoading();
        if (data.hasError == false) { 
          this.typeAccount=this.global.checkTypeAccount(data.accountType);
          objAccounts = data.accounts;
          idUser = objAccounts.AccountList[0].userID;
          sessionStorage.setItem("token", data.token);
          var requiredEmailUpdate = data.requiredEmailUpdate;
          sessionStorage.setItem("email", btoa(data.email));
          sessionStorage.setItem("name", btoa(data.name));
          sessionStorage.setItem("selectBan", btoa(data.account));
          sessionStorage.setItem("logState", btoa(JSON.stringify(false))); // revisar

          let accountName;
          let lastName: string = '';
          let name: string = '';
          if (data.name != "") {
            accountName = data.name.split(" ");
            name = accountName[0] + ' ' + accountName[1];
            for (let i = 0; i < accountName.length; i++) {
              if (i > 1) {
                lastName = lastName + ' ' + accountName[i];
              }
            }
            lastName = lastName.trim();
          }

          if (data.requiredPasswordReset == true) {
            this.global.requiredPasswordReset = true;
            this.loadingScreenService.stopLoading();
            this.router.navigate(['forgotpassword']);
          }
          else {
            if (data.username.length > 20) {
              userName2 = data.username.toString().substring(0, 20) + "...";
              sessionStorage.setItem("userName", userName2);
            }
            else {
              sessionStorage.setItem("userName", data.username);
            }

            sessionStorage.setItem("userName2", btoa(data.username));
            sessionStorage.setItem("defaultSubscriber", btoa(data.subscriber)); //revisar si se esta guardando
            sessionStorage.setItem("requiredAccountUpdate", btoa(JSON.stringify(data.requiredAccountUpdate)));//revisar si se esta guardando
            sessionStorage.setItem("firstload", btoa(JSON.stringify(false)));//revisar
            this.services.permissions(data.token, data.accountType, name, lastName).subscribe(dataPermission => {
              if (dataPermission.hasError == false) {
                sessionStorage.setItem("permissions", btoa(JSON.stringify(dataPermission)));
                sessionStorage.setItem("moduleData", btoa(JSON.stringify(dataPermission.permission)));
                this.services.accountDetails(data.token, btoa(data.subscriber), btoa(data.account)).subscribe(data2 => {
                  if (data2.HasError == false) {
                    sessionStorage.setItem("getAccount", btoa(JSON.stringify(objAccounts)));
                    sessionStorage.setItem("AccountList", btoa(JSON.stringify(objAccounts.AccountList)));
                    sessionStorage.setItem("getAccountDetails", btoa(JSON.stringify(data2)));

                    this.loadingScreenService.stopLoading();
                    this.global.session();

                    if (JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo.length > 0) {
                      if (JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].prepaidBalanceField !== null) {
                        sessionStorage.setItem("prepaidBalance", btoa(JSON.stringify(JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].prepaidBalanceField.toString())));
                        if (JSON.parse(atob(sessionStorage.getItem("prepaidBalance"))).search('CR') > -1) {
                          sessionStorage.setItem("prepaidBalance", btoa('0'));
                        }
                      }
                      sessionStorage.setItem("socRateField", btoa(JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].planInfoField.socRateField));
                    }
                    sessionStorage.setItem("popPreguntasSeguridad", btoa(JSON.stringify(data.requiredQuestions)));
                    if (requiredEmailUpdate === true) {
                      this.router.navigate(['profile/2']);
                    }
                    else {
                      this.global.suspendedAccount(data2.SubscriberInfo[0].subscriberStatusField, data.account, data.subscriber, data2.AccounInfo.billBalanceField);
                      this.router.navigate(['home']);
                    }
                  }
                  else {
                    this.loadingScreenService.stopLoading();
                    this.global.notif(data2.errorDisplay);
                  }
                });
              }
              else {
                this.loadingScreenService.stopLoading();
                this.global.notif(dataPermission.errorDesc);
              }
            });
          }
        }
        else {
          this.loadingScreenService.stopLoading();
          this.global.notif(data.errorDisplay);
        }
      });
    }
  }
  validateSubscriber() {
    this.loadingScreenService.startLoading();
    if (this.subscriber.length !== 10) {
      this.global.notif('Debe ingresar un número de suscriptor válido.');
      this.loadingScreenService.stopLoading();
    }
    else {
      if (this.subscriber.match(/[0-9]{10}/)) {
        this.services.validateSubscriberUpdate(this.subscriber, this.token).subscribe(data => {
          if (data.hasError == false) {
            this.securityCode = '';
            this.typeAccount = data.productType;
            let typeOfAccount = this.global.checkTypeAccount(this.accountType);
            if (typeOfAccount == 'postpago') {
                this.scremView=3;
            }
            else {
              this.scremView=2;
            }
            this.loadingScreenService.stopLoading();
          }
          else {
            this.loadingScreenService.stopLoading();
            this.global.notif(data.errorDisplay);
          }
        });
      }
      else {
        this.global.notif('Debe ingresar un número de suscriptor válido.');
        this.loadingScreenService.stopLoading();
      }
    }
  }
  goToLogin() {
    this.router.navigate(['login']);
  }
  resendCode() {
    this.loadingScreenService.startLoading();
    this.services.validateAccount(this.subscriber).subscribe(data => {
      this.loadingScreenService.stopLoading();
      if(data.HasError==false){
        this.txtType = this.global.checkTypeAccount(this.accountType);
        this.global.notif('Código de seguridad enviado.');
      }
      else{
        this.global.notif(data.errorDesc);
      }
      
    });
  }
  getLatestSuscriberNumbers() {
    return this.subscriber.slice(this.subscriber.length - 4, this.subscriber.length);
  }
}
